var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetireWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3286_1811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4468 76.4258L60.1953 12.0314C58.0859 8.28125 54.2771 6.05469 49.9999 6.05469C45.7228 6.05469 41.914 8.28125 39.8046 11.9727L1.50228 76.4846C-0.548692 80.176 -0.490098 84.5119 1.61967 88.1447C3.72904 91.7775 7.53725 93.9455 11.6976 93.9455H88.3103C92.4706 93.9455 96.279 91.7775 98.3882 88.1447C100.498 84.5117 100.556 80.176 98.4468 76.4258Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3881 88.1445C96.2787 91.7773 92.4705 93.9453 88.3102 93.9453H50V6.05469C54.2771 6.05469 58.0859 8.28125 60.1953 12.0314L98.4469 76.426C100.556 80.176 100.498 84.5117 98.3881 88.1445Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8594 67.5781H44.1406V79.2969H55.8594V67.5781Z",
    fill: "#4A696F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8594 32.4219H44.1406V61.7188H55.8594V32.4219Z",
    fill: "#4A696F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8594 32.4219H50V61.7188H55.8594V32.4219Z",
    fill: "#3E5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8594 67.5781H50V79.2969H55.8594V67.5781Z",
    fill: "#3E5959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3286_1811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetireWarning);
export default __webpack_public_path__ + "static/media/retire_warning.7bd6c245cb06543f891ce93362f808db.svg";
export { ForwardRef as ReactComponent };